// extracted by mini-css-extract-plugin
export default {"container":"iRfBS3axTpmGZk5B0kjO"};